<template>
  <div
    v-if="isVisible"
    class="backdrop"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="expired-dialog-title"
    aria-describedby="expired-dialog-description">
    <div class="expired-dialog">
      <h5 id="expired-dialog-title">
        {{ tStatic('caiSessionExpiredTitle') }}
      </h5>
      <p id="expired-dialog-description">
        {{ tStatic('caiSessionExpiredDescription') }}
      </p>
      <hr>
      <div class="actions">
        <button
          class="ok"
          type="button"
          :aria-label="tStatic('caiAccessibilityCloseSessionExpiredInfoText')"
          @click="onOk">
          {{ tStatic('genericOk') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    onOk: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.backdrop {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.expired-dialog {
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  background-color: #fff;
  z-index: 200;
  width: 80%;
  border-radius: 0.5rem;
  padding: 0.75rem;
  margin: auto;

  h5 {
    font-size: 1.25rem;
    font-weight: bold;
  }

  p {
    font-size: 13px;
  }

  hr {
    margin: 1rem 0;
  }

  .actions {
    align-self: flex-end;
  }
}

.ok {
  padding: 0.5rem;
  width: 6rem;
  font-size: 13px;
  font-weight: bold;
  border-radius: 1rem;
  background-color: #1c508b;
  border: none;
  color: #fff;
  cursor: pointer;

  &:hover {
    background-color: #466e9c;
  }
}
</style>
